export default {
  StatisticalAnalysis: '统计分析',
  BusinessDataAnalysis: '业务数据分析',
  GatewayServiceMonitor: '网关服务监控',
  NetworkQualityMonitor: '网络质量监控',
  NearlyHour: (hour: number) => `近${hour}小时`,
  SearchGatewayCpePlaceholder: '搜索设备号/设备别名/网关号/分支机构',
  TotalUpStream: '总带宽峰值-上行',
  TotalDownStream: '总带宽峰值-下行',
  Bandwidth: '带宽',
  BandwidthUtilization: '带宽使用率',
  BarChartTitle: '分支机构流量使用（top20）',
  NICThroughput: '网卡吞吐量',
  NetworkCardPacketLoss: '网卡丢包',
  EquipmentLoad: '设备负载',
  CPUUsage: 'cpu使用率',
  MemoryUsage: '内存使用率',
  DiskUsage: '磁盘使用率',
  SearchSourceDevice: '搜索来源设备号/设备别名/网关号/分支机构',
  SearchTargetDevice: '搜索目标设备号/设备别名/网关号/分支机构',
  AllProtocol: '全部协议',
  AlarmList: '告警事件',
  SelectPhysical: '选择物理口',
}